import React from 'react';
import { ArrowDownToLineIcon, BookOpenIcon } from 'lucide-react';
import { downloadUrl, libraryBooks, viewUrl } from '../data/library';
import { BookCover } from './BookCover';
import { SectionHeading } from './SectionHeading';
export function SixBooks() {
  return <section aria-label="Your six books" id="library" className="scroll-mt-24" data-id="element-246" data-mp="3ck8ssboahd23">
      <SectionHeading index="01" title="Your six books" note="Choose a book. Gather your materials. Build together." data-id="element-247" data-mp="38lrijj9knmgg">
        <span className="inline-flex items-center rounded-full bg-sun px-3 py-1.5 font-sans text-[11px] font-semibold tracking-[0.12em] text-navy" data-id="element-248" data-mp="2fwucceimxg42">
          BUILD &amp; DISCOVER
        </span>
      </SectionHeading>

      <ul className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-249" data-mp="2ovxwzmxga3ko">
        {libraryBooks.map(book => {
        const number = String(book.n).padStart(2, '0');
        return <li key={book.fileId} className="flex flex-col rounded-[18px] border border-navy/10 bg-white p-5" data-id="element-250" data-mp="1x6mg8gdcrpxd">
              <div className="flex aspect-[3/4] items-center justify-center overflow-hidden rounded-[12px] border border-navy/5 bg-paper p-3" data-id="element-251" data-mp="10m4rxhvge9bx">
                <BookCover book={book} decorative data-id="element-252" data-mp="1adimrccgmkyq" />
              </div>

              <p className="mt-5 font-sans text-[11px] font-semibold tracking-[0.16em] text-[#B07E00]" data-id="element-253" data-mp="1fcvgmh1r0sat">
                BOOK {number}
              </p>
              <h3 className="mt-1 font-display text-[21px] font-semibold leading-snug text-navy" data-id="element-254" data-mp="hqo3ujvajtnd">
                {book.title}
              </h3>
              <p className="mt-2 font-sans text-[14.5px] leading-relaxed text-navy/65" data-id="element-255" data-mp="rnaq9d39msri">
                {book.blurb}
              </p>
              <p className="tnum mt-3 font-sans text-[12.5px] text-navy/45" data-id="element-256" data-mp="wnf40vcsh9e1">
                {book.projects} projects &amp; challenges · {book.pages} pages
              </p>

              <div className="mt-auto flex flex-wrap gap-2 pt-6" data-id="element-257" data-mp="281159evxb1fx">
                <a href={viewUrl(book.fileId)} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-[12px] bg-navy px-4 py-2.5 font-sans text-[13px] font-medium text-paper transition-colors duration-150 ease-out hover:bg-[#0A2440] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy focus-visible:ring-offset-2 focus-visible:ring-offset-white" data-id="element-258" data-mp="283n8x3fp0wsv">
                  <BookOpenIcon aria-hidden="true" className="h-4 w-4" strokeWidth={2} data-id="element-259" data-mp="3lefo94mckxfk" />
                  Open book
                  <span className="sr-only" data-id="element-260" data-mp="3gd9ur4kv564z">
                    {' '}
                    {number} {book.title}
                  </span>
                </a>
                <a href={downloadUrl(book.fileId)} className="inline-flex items-center gap-2 rounded-[12px] border border-navy/20 px-4 py-2.5 font-sans text-[13px] font-medium text-navy transition-colors duration-150 ease-out hover:border-navy/45 hover:bg-paper focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy focus-visible:ring-offset-2 focus-visible:ring-offset-white" data-id="element-261" data-mp="3pezm6aeqw52r">
                  <ArrowDownToLineIcon aria-hidden="true" className="h-4 w-4" strokeWidth={2} data-id="element-262" data-mp="2dmii7bmwe89n" />
                  Download PDF
                  <span className="sr-only" data-id="element-263" data-mp="2il21t5e0r7yu">
                    {' '}
                    for book {number} {book.title}
                  </span>
                </a>
              </div>
            </li>;
      })}
      </ul>
    </section>;
}